import { A } from '../actions/imports';
import update from 'immutability-helper';

const initialState = {
  uploadFile: {
    isFetching: false,
    error: null,
  },
  updateImportTask: {
    isFetching: false,
    error: null,
  },
  startTaskProcess: {
    isFetching: false,
    error: null,
  },
  getImportTasks: {
    isFetching: false,
    error: null,
  },
  getImportTaskById: {
    isFetching: false,
    error: null,
  },
  getFieldList: {
    isFetching: false,
    error: null,
  },
  importParsedProducts: {
    isFetching: false,
    error: null,
  },
  getSkuImportTemplate: {
    isFetching: false,
    error: null,
  },
};

const imports = (state = initialState, action) => {
  switch (action.type) {
    case A.REQUEST_UPLOAD_FILE:
      return update(state, {
        uploadFile: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPLOAD_FILE:
      return update(state, {
        uploadFile: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPLOAD_FILE:
      return update(state, {
        uploadFile: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_IMPORT_TASK:
      return update(state, {
        updateImportTask: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_IMPORT_TASK:
      return update(state, {
        updateImportTask: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_IMPORT_TASK:
      return update(state, {
        updateImportTask: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_START_TASK_PROCESS:
      return update(state, {
        startTaskProcess: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_START_TASK_PROCESS:
      return update(state, {
        startTaskProcess: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_START_TASK_PROCESS:
      return update(state, {
        startTaskProcess: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_IMPORT_TASKS:
      return update(state, {
        getImportTasks: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_IMPORT_TASKS:
      return update(state, {
        getImportTasks: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_IMPORT_TASKS:
      return update(state, {
        getImportTasks: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_IMPORT_TASK_BY_ID:
      return update(state, {
        getImportTaskById: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_IMPORT_TASK_BY_ID:
      return update(state, {
        getImportTaskById: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_IMPORT_TASK_BY_ID:
      return update(state, {
        getImportTaskById: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_FIELD_LIST:
      return update(state, {
        getFieldList: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_FIELD_LIST:
      return update(state, {
        getFieldList: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_FIELD_LIST:
      return update(state, {
        getFieldList: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_IMPORT_PARSED_PRODUCTS:
      return update(state, {
        importParsedProducts: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_IMPORT_PARSED_PRODUCTS:
      return update(state, {
        importParsedProducts: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_IMPORT_PARSED_PRODUCTS:
      return update(state, {
        importParsedProducts: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_SKU_IMPORT_TEMPLATE:
      return update(state, {
        getSkuImportTemplate: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_SKU_IMPORT_TEMPLATE:
      return update(state, {
        getSkuImportTemplate: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_SKU_IMPORT_TEMPLATE:
      return update(state, {
        getSkuImportTemplate: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    default:
      return state;
  }
};

export default imports;
